module.exports = __webpack_public_path__ + "static/media/VIDEO-COUNT-4.4f9c04df.png";